var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-reports"},[_c('reports-widget',{attrs:{"config":_vm.reportsConfig,"offer_id":_vm.filters.offer_id,"placement_id":_vm.filters.placement_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }